export const translations = {
    en: {
        common: {
            next: "NEXT",
            back: "BACK",
            play: "PLAY",
            register: "REGISTER",
            login: "LOGIN",
            gotIt: "GOT IT!",
            loading: "Loading..."
        },
        rounds: {
            nextRound: "NEXT ROUND",
            getReady: "GET READY",
            speedLabel: "SPEED"
        },
        landing: {
            playAsGuest: "Play as guest",
            signIn: "Sign in",
            tagline: "Grow your cutest PixelBlob and paint dreamy pixel worlds."
        },
        auth: {
            email: "EMAIL",
            password: "PASSWORD",
            rememberMe: "REMEMBER ME",
            noAccountStart: "I don't have an account, start playing",
            forgotPassword: "Forgot password?",
            forgotPasswordTitle: "RESET PASSWORD",
            forgotPasswordDescription: "Enter your email and we'll send you a reset link.",
            sendResetLink: "SEND RESET LINK",
            resetPasswordTitle: "NEW PASSWORD",
            updatePassword: "UPDATE PASSWORD",
            registerTitle: "REGISTER",
            play: "PLAY",
            shop: "SHOP",
            leaderboards: "LEADERBOARDS",
            myProfile: "MY PROFILE",
            friends: "FRIENDS",
            logout: "LOGOUT"
        },
        modes: {
            infinite: "INFINITE",
            challenges: "CHALLENGES",
            allGames: "ALL GAMES",
            infiniteLabel: "INFINITE MODE"
        },
        onboarding: {
            step1Title: "WELCOME!",
            step1Text: "Welcome to <strong>PIXELBLOB</strong>! <br><br> Raise your tiny blob and let it paint adorable pixel art.",
            step2Title: "HOW TO PLAY?",
            step2Text: "Read the instruction in the center and act instantly. <br><br> Tap, swipe, shake... Stay sharp!",
            step3Title: "GLORY & PROMOTION!",
            step3Text: "Being top-ranked allows you to display a <strong>personal link</strong> (Social, Portfolio, etc.) to the entire community. <br><br> Get ranked, make your own promotion!",
            step4Title: "THE MODES",
            step4Text: "Use the <strong>PLAY</strong> button to test your limits in INFINITE or take on CHALLENGES!",
            step5Title: "PERSONALIZE",
            step5Text: "Earn coins to unlock new colors and effects in the <strong>SHOP</strong>!",
            step6Title: "LEADERBOARDS",
            step6Text: "Climb to the top to gain visibility and promote your link to the entire community!",
            step7Title: "MY PROFILE",
            step7Text: "Configure your <strong>Promotion Link</strong> and register to save your progress!",
            step8Title: "FRIENDS",
            step8Text: "Add your friends and share your cutest blob creations together!",
            step9Title: "WELCOME GIFT!",
            step9Text: "To get you started, we've gifted you <strong>{coins} COINS</strong> and <strong>{energy} ENERGY</strong>! <br><br> Use them wisely to climb the ranks!",
            letsPlay: "LET'S PLAY!",
            skipToGift: "SKIP TO GIFT",
            goodLuck: "GOOD LUCK!",
            tipInfiniteTitle: "INFINITE MODE",
            tipInfiniteText: "The place to <strong>discover and unlock all 100 games</strong>! <br><br> Games get faster and faster. One mistake and it's over.",
            tipChallengesTitle: "CHALLENGES MODE",
            tipChallengesText: "Specific goals for each microgame. <br><br> Complete them to unlock coins and XP!",
            tipAllGamesTitle: "ALL GAMES",
            tipAllGamesText: "Practice modes for games you've discovered in <strong>INFINITE</strong> mode. <br><br> Climb the local and global rankings for each game!"
        },
        notifications: {
            guestBanner: "Guest account: register to save your progress!",
            codeCopied: "Code copied!",
            noEnergyRefill: "NO ENERGY! REFILL IN SHOP",
            challengeFailed: "CHALLENGE FAILED",
            unlocked: "Unlocked!",
            notEnoughCoins: "Not enough coins!",
            scoreCopied: "Score & Code copied to clipboard!",
            creatingGuest: "CREATING GUEST ACCOUNT...",
            guestCreationFailed: "FAILED TO CREATE GUEST. TRY LOGIN?",
            verifyingPurchase: "Verifying Purchase...",
            premiumActivated: "PREMIUM ACTIVATED! INFINITE ENERGY!",
            purchaseCanceled: "Purchase Canceled.",
            coinsAdded: "+{amount} COINS! 💰",
            challengeComplete: "CHALLENGE COMPLETE! {stars} STAR(S)!",
            runEndedScore: "RUN ENDED. SCORE: {score}",
            noEnergyLeft: "NO ENERGY LEFT!",
            accountSaved: "ACCOUNT SAVED!"
        },
        convert: {
            title: "SAVE PROGRESS",
            description: "Convert your guest account to save your coins and progress permanently!",
            newUsername: "NEW USERNAME",
            confirmPassword: "CONFIRM PASSWORD",
            saveProfile: "SAVE MY PROFILE",
            later: "LATER"
        },
        errors: {
            loginRequiredFields: "Please enter email and password",
            emailRequired: "Please enter your email",
            allFieldsRequired: "All fields are required",
            passwordMismatch: "Passwords do not match",
            invalidResetLink: "Invalid password reset link",
            loginFirst: "Please login first!"
        },
        challenges: {
            runTitle: "CHALLENGE RUN",
            backToMenu: "BACK TO MENU"
        },
        cookies: {
            message: "We use cookies to improve your user experience and remember your progress, in accordance with GDPR. By continuing, you agree to our use of cookies.",
            accept: "ACCEPT",
            refuse: "REFUSE"
        },
        allGames: {
            title: "ALL GAMES",
            banner: "Discover new games in <strong>INFINITE</strong> mode to unlock them here for practice and high scores!",
            unlockedLabel: "UNLOCKED:",
            searchPlaceholder: "SEARCH GAMES...",
            champ: "CHAMP"
        },
        shop: {
            title: "SHOP",
            colors: "COLORS",
            effects: "EFFECTS",
            coins: "COINS"
        },
        leaderboard: {
            title: "LEADERBOARDS",
            searchPlaceholder: "SEARCH LEADERBOARDS...",
            globalRank: "GLOBAL RANK",
            top: "TOP",
            noScores: "NO SCORES YET",
            noScoresShort: "No scores yet.",
            previewLoading: "LEADERBOARD (LOADING...)",
            singleTitle: "LEADERBOARD"
        },
        profile: {
            title: "MY PROFILE",
            xpProgress: "XP PROGRESS",
            stats: "STATS",
            totalCoins: "COINS:",
            gamesUnlocked: "GAMES UNLOCKED:",
            promotionLink: "PROMOTION LINK",
            promotionHint: "Top players can promote a link here!",
            saveLink: "SAVE LINK",
            personalBests: "PERSONAL BESTS",
            emptyBestsHint: "No high scores yet! 🎮<br><br>Play <strong>INFINITE MODE</strong> or <strong>CHALLENGES</strong> to see your best scores appear here and climb the leaderboards!",
            levelShort: "LVL",
            languageLabel: "Language:"
        },
        friends: {
            title: "FRIENDS",
            yourCode: "YOUR CODE:",
            enterCode: "ENTER CODE",
            add: "ADD",
            noFriendsYet: "No friends yet.",
            invalidCode: "INVALID CODE FORMAT",
            added: "FRIEND ADDED!",
            noFriendsAdded: "No friends added yet.",
            shareCode: "Share your code!",
            view: "VIEW",
            friendStats: "Friend's Stats"
        },
        games: {
            TapGame: "Tap",
            SwipeGame: "Swipe",
            MazeGame: "Maze",
            SoccerGame: "Soccer",
            HoldGame: "Hold",
            ShakeGame: "Shake",
            ChargeGame: "Charge",
            DodgeGame: "Dodge",
            MatchGame: "Match",
            TypeGame: "Type",
            SpinGame: "Spin",
            CatchGame: "Catch",
            CountGame: "Count",
            FindGame: "Find",
            ConnectGame: "Connect",
            DontMoveGame: "Don't Move",
            PumpGame: "Pump",
            SliceGame: "Slice",
            UnlockGame: "Unlock",
            SortGame: "Sort",
            StopwatchGame: "Stopwatch",
            WhackGame: "Whack",
            DefendGame: "Defend",
            BalanceGame: "Balance",
            AlignGame: "Align",
            FillGame: "Fill",
            StackGame: "Stack",
            CleanGame: "Clean",
            CrackGame: "Crack",
            TraceGame: "Trace",
            DodgeVerticalGame: "Dive",
            SimonGame: "Simon",
            MathGame: "Math",
            ShootGame: "Shoot",
            FanGame: "Fan",
            OrderGame: "Order",
            JumpGame: "Jump",
            DuckGame: "Duck",
            ReelGame: "Reel",
            ShaveGame: "Shave",
            PetGame: "Pet",
            ToastGame: "Toast",
            AnswerGame: "Answer",
            HighFiveGame: "High Five",
            DrinkGame: "Drink",
            BlowGame: "Blow",
            ScratchGame: "Scratch",
            SquashGame: "Squash",
            GolfGame: "Golf",
            BowlingGame: "Bowling",
            ArcheryGame: "Archery",
            SnatchGame: "Snatch",
            SafeCrackGame: "SafeCrack",
            MorseGame: "Morse",
            MergeGame: "Merge",
            PeelGame: "Peel",
            ScaleGame: "Scale",
            TugGame: "Tug",
            ParkGame: "Park",
            FlySwatGame: "FlySwat",
            BasketGame: "Basket",
            TrafficGame: "Traffic",
            UmbrellaGame: "Umbrella",
            FlipGame: "Flip",
            SawGame: "Saw",
            TankGame: "Tank",
            ZipperGame: "Zipper",
            NeedleGame: "Needle",
            PizzaGame: "Pizza",
            PlugGame: "Plug",
            UnscrewGame: "Unscrew",
            RipGame: "Rip",
            SprayGame: "Spray",
            TunerGame: "Tuner",
            FileGame: "File",
            IgniteGame: "Ignite",
            CrushGame: "Crush",
            StampGame: "Stamp",
            ShredGame: "Shred",
            FlickGame: "Flick",
            DunkGame: "Dunk",
            SpreadGame: "Spread",
            UnrollGame: "Unroll",
            PokeGame: "Poke",
            FishGame: "Fish",
            SkateGame: "Skate",
            KiteGame: "Kite",
            PingPongGame: "PingPong",
            PlantGame: "Plant",
            PianoGame: "Piano",
            PoolGame: "Pool",
            DartGame: "Dart",
            CardGame: "Card",
            PhotoGame: "Photo",
            OrbitGame: "Orbit",
            MagnetGame: "Magnet",
            RopeGame: "Rope",
            ReactionGame: "Reaction",
            KeepUpGame: "Keep Up",
            SpaceGame: "Space"
        },
        ui: {
            guestAccountLabel: "GUEST ACCOUNT: REGISTER TO SAVE YOUR PROGRESS!"
        },
        microgames: {
            survive: "SURVIVE!",
            ready: "READY?"
        },
        tutorial: {
            controls: "CONTROLS",
            objective: "OBJECTIVE",
            play: "PLAY",
            close: "CLOSE",
            tapToPlay: "TAP TO START",
            badge: "?",
            watchDemo: "WATCH HOW TO WIN",
            autoResume: "AUTO-RESUME IN {seconds}s",
            skipDemo: "CONTINUE",
            dontShowAgain: "DON'T SHOW AGAIN"
        }
    },
    fr: {
        common: {
            next: "SUIVANT",
            back: "RETOUR",
            play: "JOUER",
            register: "S'INSCRIRE",
            login: "CONNEXION",
            gotIt: "COMPRIS !",
            loading: "Chargement..."
        },
        rounds: {
            nextRound: "PROCHAIN ROUND",
            getReady: "PRÊT ?",
            speedLabel: "VITESSE"
        },
        landing: {
            playAsGuest: "Jouer en invité",
            signIn: "Se connecter",
            tagline: "Fais grandir ton PixelBlob adorable et peins des mondes pastel."
        },
        auth: {
            email: "EMAIL",
            password: "MOT DE PASSE",
            rememberMe: "SE SOUVENIR DE MOI",
            noAccountStart: "Je n'ai pas de compte, commencer à jouer",
            forgotPassword: "Mot de passe oublié ?",
            forgotPasswordTitle: "RÉINITIALISER",
            forgotPasswordDescription: "Entre ton email et nous t'enverrons un lien de réinitialisation.",
            sendResetLink: "ENVOYER LE LIEN",
            resetPasswordTitle: "NOUVEAU MOT DE PASSE",
            updatePassword: "METTRE À JOUR",
            registerTitle: "INSCRIPTION",
            play: "JOUER",
            shop: "BOUTIQUE",
            leaderboards: "CLASSEMENTS",
            myProfile: "MON PROFIL",
            friends: "AMIS",
            logout: "DECONNEXION"
        },
        modes: {
            infinite: "INFINI",
            challenges: "DÉFIS",
            allGames: "TOUS LES JEUX",
            infiniteLabel: "MODE INFINI"
        },
        onboarding: {
            step1Title: "BIENVENUE !",
            step1Text: "Bienvenue dans <strong>PIXELBLOB</strong> ! <br><br> Fais évoluer ton blob pixel et crée de l'art vivant kawaii.",
            step2Title: "COMMENT JOUER ?",
            step2Text: "Lis l'instruction au centre et passes à l'action. <br><br> Tape, balaye, vise... Reste concentré !",
            step3Title: "GLOIRE & PROMO !",
            step3Text: "Être bien classé te permet d'afficher un <strong>lien personnel</strong> (social, portfolio, etc.) à toute la communauté. <br><br> Domine les classements et fais ta promo !",
            step4Title: "LES MODES",
            step4Text: "Utilise <strong>JOUER</strong> pour tester tes limites en INFINI ou relever les DÉFIS !",
            step5Title: "PERSONNALISE",
            step5Text: "Gagne des pièces pour débloquer de nouveaux skins et effets dans la <strong>BOUTIQUE</strong> !",
            step6Title: "CLASSEMENTS",
            step6Text: "Domine les classements pour partager ton lien!",
            step7Title: "MON PROFIL",
            step7Text: "Configure ton <strong>lien de promotion</strong> et inscris-toi pour sauvegarder ta progression !",
            step8Title: "AMIS",
            step8Text: "Ajoute tes amis et partage vos créations PixelBlob les plus mignonnes !",
            step9Title: "CADEAU DE BIENVENUE !",
            step9Text: "Pour bien commencer, on t'a offert <strong>{coins} PIÈCES</strong> et <strong>{energy} ÉNERGIES</strong> ! <br><br> Utilise-les intelligemment pour atteindre les sommets !",
            letsPlay: "C'EST PARTI !",
            skipToGift: "PASSER AU CADEAU",
            goodLuck: "BONNE CHANCE !",
            tipInfiniteTitle: "MODE INFINI",
            tipInfiniteText: "L'endroit idéal pour <strong>découvrir et débloquer les 100 jeux</strong> ! <br><br> Les jeux accélèrent de plus en plus. Une erreur et c'est fini.",
            tipChallengesTitle: "MODE DÉFIS",
            tipChallengesText: "Des objectifs spécifiques pour chaque micro-jeu. <br><br> Complète-les pour débloquer pièces et XP !",
            tipAllGamesTitle: "TOUS LES JEUX",
            tipAllGamesText: "Entraîne-toi sur les jeux découverts en mode <strong>INFINI</strong>. <br><br> Monte dans les classements locaux et globaux !"
        },
        notifications: {
            guestBanner: "Invité : inscris-toi pour sauvegarder ta progression !",
            codeCopied: "Code copié !",
            noEnergyRefill: "PLUS D'ÉNERGIE ! RECHARGE DANS LA BOUTIQUE",
            challengeFailed: "DÉFI ÉCHOUÉ",
            unlocked: "Débloqué !",
            notEnoughCoins: "Pas assez de pièces !",
            scoreCopied: "Score et code copiés dans le presse-papiers !",
            creatingGuest: "CREATION DU COMPTE INVITE...",
            guestCreationFailed: "ÉCHEC CRÉATION INVITÉ. TENTE LA CONNEXION ?",
            verifyingPurchase: "Vérification de l'achat...",
            premiumActivated: "PREMIUM ACTIVÉ ! ÉNERGIE INFINIE !",
            purchaseCanceled: "Achat annulé.",
            coinsAdded: "+{amount} PIÈCES! 💰",
            challengeComplete: "DÉFI TERMINÉ ! {stars} ÉTOILE(S) !",
            runEndedScore: "RUN TERMINE. SCORE : {score}",
            noEnergyLeft: "PLUS D'ÉNERGIE !",
            accountSaved: "COMPTE SAUVEGARDÉ !"
        },
        convert: {
            title: "SAUVEGARDER",
            description: "Convertis ton compte invité pour sauvegarder définitivement tes pièces et ta progression !",
            newUsername: "NOUVEAU PSEUDO",
            confirmPassword: "CONFIRMER LE MOT DE PASSE",
            saveProfile: "SAUVEGARDER MON PROFIL",
            later: "PLUS TARD"
        },
        errors: {
            loginRequiredFields: "Merci d'entrer email et mot de passe",
            emailRequired: "Merci d'entrer ton email",
            allFieldsRequired: "Tous les champs sont requis",
            passwordMismatch: "Les mots de passe ne correspondent pas",
            invalidResetLink: "Lien de réinitialisation invalide",
            loginFirst: "Connecte-toi d'abord !"
        },
        challenges: {
            runTitle: "RUN DE DÉFI",
            backToMenu: "RETOUR AU MENU"
        },
        cookies: {
            message: "Nous utilisons des cookies pour améliorer votre expérience et mémoriser votre progression, conformément au RGPD. En continuant, vous acceptez notre utilisation des cookies.",
            accept: "ACCEPTER",
            refuse: "REFUSER"
        },
        allGames: {
            title: "TOUS LES JEUX",
            banner: "Découvre de nouveaux jeux en mode <strong>INFINI</strong> pour les débloquer ici, t'entraîner et faire les meilleurs scores !",
            unlockedLabel: "DÉBLOQUÉS :",
            searchPlaceholder: "RECHERCHER UN JEU...",
            champ: "CHAMP"
        },
        shop: {
            title: "BOUTIQUE",
            colors: "COULEURS",
            effects: "EFFETS",
            coins: "PIÈCES"
        },
        leaderboard: {
            title: "CLASSEMENTS",
            searchPlaceholder: "RECHERCHER UN CLASSEMENT...",
            globalRank: "RANG GLOBAL",
            top: "TOP",
            noScores: "AUCUN SCORE POUR LE MOMENT",
            noScoresShort: "Aucun score pour le moment.",
            previewLoading: "CLASSEMENT (CHARGEMENT...)",
            singleTitle: "CLASSEMENT"
        },
        profile: {
            title: "MON PROFIL",
            xpProgress: "PROGRESSION XP",
            stats: "STATS",
            totalCoins: "PIÈCES :",
            gamesUnlocked: "JEUX DÉBLOQUÉS :",
            promotionLink: "LIEN DE PROMOTION",
            promotionHint: "Les meilleurs joueurs peuvent promouvoir un lien ici !",
            saveLink: "ENREGISTRER LE LIEN",
            personalBests: "MEILLEURS SCORES",
            emptyBestsHint: "Aucun meilleur score pour le moment ! 🎮<br><br>Joue en <strong>MODE INFINI</strong> ou en <strong>CHALLENGES</strong> pour afficher tes meilleurs scores ici et grimper dans les classements !",
            levelShort: "NIV",
            languageLabel: "Langue :"
        },
        friends: {
            title: "AMIS",
            yourCode: "TON CODE :",
            enterCode: "ENTRER UN CODE",
            add: "AJOUTER",
            noFriendsYet: "Aucun ami pour le moment.",
            invalidCode: "FORMAT DE CODE INVALIDE",
            added: "AMI AJOUTÉ !",
            noFriendsAdded: "Aucun ami ajouté pour le moment.",
            shareCode: "Partage ton code !",
            view: "VOIR",
            friendStats: "Stats de l'ami"
        },
        games: {
            TapGame: "Tap",
            SwipeGame: "Swipe",
            MazeGame: "Labyrinthe",
            SoccerGame: "Football",
            HoldGame: "Maintien",
            ShakeGame: "Secoue",
            ChargeGame: "Charge",
            DodgeGame: "Esquive",
            MatchGame: "Associe",
            TypeGame: "Tape",
            SpinGame: "Tourne",
            CatchGame: "Attrape",
            CountGame: "Compte",
            FindGame: "Trouve",
            ConnectGame: "Relie",
            DontMoveGame: "Ne Bouge Pas",
            PumpGame: "Pompe",
            SliceGame: "Tranche",
            UnlockGame: "Déverrouille",
            SortGame: "Trie",
            StopwatchGame: "Chrono",
            WhackGame: "Frappe",
            DefendGame: "Défends",
            BalanceGame: "Équilibre",
            AlignGame: "Aligne",
            FillGame: "Remplis",
            StackGame: "Empile",
            CleanGame: "Nettoie",
            CrackGame: "Casse",
            TraceGame: "Trace",
            DodgeVerticalGame: "Plonge",
            SimonGame: "Simon",
            MathGame: "Maths",
            ShootGame: "Tir",
            FanGame: "Ventilo",
            OrderGame: "Ordre",
            JumpGame: "Saut",
            DuckGame: "Baisse-toi",
            ReelGame: "Mouline",
            ShaveGame: "Rase",
            PetGame: "Apaise",
            ToastGame: "Toast",
            AnswerGame: "Réponse",
            HighFiveGame: "High Five",
            DrinkGame: "Bois",
            BlowGame: "Souffle",
            ScratchGame: "Gratte",
            SquashGame: "Écrase",
            GolfGame: "Golf",
            BowlingGame: "Bowling",
            ArcheryGame: "Tir à l'arc",
            SnatchGame: "Saisis",
            SafeCrackGame: "Coffre",
            MorseGame: "Morse",
            MergeGame: "Fusion",
            PeelGame: "Épluche",
            ScaleGame: "Balance",
            TugGame: "Tir à la corde",
            ParkGame: "Parking",
            FlySwatGame: "Tapette",
            BasketGame: "Panier",
            TrafficGame: "Trafic",
            UmbrellaGame: "Parapluie",
            FlipGame: "Flip",
            SawGame: "Scie",
            TankGame: "Tank",
            ZipperGame: "Fermeture",
            NeedleGame: "Aiguille",
            PizzaGame: "Pizza",
            PlugGame: "Prise",
            UnscrewGame: "Dévisse",
            RipGame: "Déchire",
            SprayGame: "Spray",
            TunerGame: "Accordeur",
            FileGame: "Lime",
            IgniteGame: "Allume",
            CrushGame: "Écrase",
            StampGame: "Tampon",
            ShredGame: "Broie",
            FlickGame: "Pichenette",
            DunkGame: "Dunk",
            SpreadGame: "Étale",
            UnrollGame: "Déroule",
            PokeGame: "Pique",
            FishGame: "Poisson",
            SkateGame: "Skate",
            KiteGame: "Cerf-volant",
            PingPongGame: "Ping Pong",
            PlantGame: "Plante",
            PianoGame: "Piano",
            PoolGame: "Billard",
            DartGame: "Fléchette",
            CardGame: "Carte",
            PhotoGame: "Photo",
            OrbitGame: "Orbite",
            MagnetGame: "Aimant",
            RopeGame: "Corde",
            ReactionGame: "Réflexe",
            KeepUpGame: "Garde le rythme",
            SpaceGame: "Espace"
        },
        ui: {
            guestAccountLabel: "COMPTE INVITÉ : INSCRIS-TOI POUR SAUVEGARDER TA PROGRESSION !"
        },
        microgames: {
            survive: "SURVIS !",
            ready: "PRÊT ?"
        },
        tutorial: {
            controls: "CONTRÔLES",
            objective: "OBJECTIF",
            play: "JOUER",
            close: "FERMER",
            tapToPlay: "APPUYER POUR COMMENCER",
            badge: "?",
            watchDemo: "REGARDE COMMENT GAGNER",
            autoResume: "REPRISE DANS {seconds}s",
            skipDemo: "CONTINUER",
            dontShowAgain: "NE PLUS AFFICHER"
        }
    },
    es: {
        common: {
            next: "SIGUIENTE",
            back: "ATRÁS",
            play: "JUGAR",
            register: "REGISTRO",
            login: "INICIAR SESIÓN",
            gotIt: "ENTENDIDO",
            loading: "Cargando..."
        },
        rounds: {
            nextRound: "SIGUIENTE RONDA",
            getReady: "PREPÁRATE",
            speedLabel: "VELOCIDAD"
        },
        landing: {
            playAsGuest: "Jugar como invitado",
            signIn: "Iniciar sesión",
            tagline: "Haz crecer tu PixelBlob adorable y pinta mundos de píxeles kawaii."
        },
        auth: {
            email: "EMAIL",
            password: "CONTRASEÑA",
            rememberMe: "RECORDARME",
            noAccountStart: "No tengo cuenta, empezar a jugar",
            forgotPassword: "¿Olvidaste tu contraseña?",
            forgotPasswordTitle: "RESTABLECER CONTRASEÑA",
            forgotPasswordDescription: "Ingresa tu email y te enviaremos un enlace de restablecimiento.",
            sendResetLink: "ENVIAR ENLACE",
            resetPasswordTitle: "NUEVA CONTRASEÑA",
            updatePassword: "ACTUALIZAR CONTRASEÑA",
            registerTitle: "REGISTRO",
            play: "JUGAR",
            shop: "TIENDA",
            leaderboards: "CLASIFICACIONES",
            myProfile: "MI PERFIL",
            friends: "AMIGOS",
            logout: "CERRAR SESION"
        },
        modes: {
            infinite: "INFINITO",
            challenges: "DESAFÍOS",
            allGames: "TODOS LOS JUEGOS",
            infiniteLabel: "MODO INFINITO"
        },
        onboarding: {
            step1Title: "¡BIENVENIDO!",
            step1Text: "Bienvenido a <strong>PIXELBLOB</strong>. <br><br> Cría tu blob de píxeles y crea arte viviente kawaii.",
            step2Title: "¿CÓMO JUGAR?",
            step2Text: "Lee la instrucción en el centro y actúa al instante. <br><br> Tap, swipe, shake... ¡Mantente alerta!",
            step3Title: "¡GLORIA Y PROMOCIÓN!",
            step3Text: "Estar en lo más alto te permite mostrar un <strong>enlace personal</strong> (social, portfolio, etc.) a toda la comunidad. <br><br> ¡Sube en el ranking y promociónate!",
            step4Title: "LOS MODOS",
            step4Text: "Usa el botón <strong>JUGAR</strong> para probar tus límites en INFINITO o afrontar DESAFÍOS!",
            step5Title: "PERSONALIZA",
            step5Text: "Gana monedas para desbloquear nuevos colores y efectos en la <strong>TIENDA</strong>.",
            step6Title: "CLASIFICACIONES",
            step6Text: "Llega a la cima para ganar visibilidad y promocionar tu enlace a toda la comunidad.",
            step7Title: "MI PERFIL",
            step7Text: "Configura tu <strong>enlace de promoción</strong> y regístrate para guardar tu progreso.",
            step8Title: "AMIGOS",
            step8Text: "Agrega a tus amigos y compartan las creaciones PixelBlob más adorables.",
            step9Title: "¡REGALO DE BIENVENIDA!",
            step9Text: "Para empezar, te regalamos <strong>{coins} MONEDAS</strong> y <strong>{energy} ENERGÍA</strong>. <br><br> ¡Úsalas bien para subir en el ranking!",
            letsPlay: "¡A JUGAR!",
            skipToGift: "SALTAR AL REGALO",
            goodLuck: "¡BUENA SUERTE!",
            tipInfiniteTitle: "MODO INFINITO",
            tipInfiniteText: "El mejor lugar para <strong>descubrir y desbloquear los 100 juegos</strong>. <br><br> Los juegos van cada vez más rápido. Un error y se termina.",
            tipChallengesTitle: "MODO DESAFÍOS",
            tipChallengesText: "Objetivos específicos para cada microjuego. <br><br> Complétalos para desbloquear monedas y XP.",
            tipAllGamesTitle: "TODOS LOS JUEGOS",
            tipAllGamesText: "Practica en los juegos descubiertos en modo <strong>INFINITO</strong>. <br><br> Sube en rankings locales y globales."
        },
        notifications: {
            guestBanner: "Cuenta de invitado: regístrate para guardar tu progreso.",
            codeCopied: "¡Código copiado!",
            noEnergyRefill: "¡SIN ENERGÍA! RECARGA EN LA TIENDA",
            challengeFailed: "DESAFÍO FALLADO",
            unlocked: "¡Desbloqueado!",
            notEnoughCoins: "¡No tienes suficientes monedas!",
            scoreCopied: "Puntuación y código copiados al portapapeles.",
            creatingGuest: "CREANDO CUENTA DE INVITADO...",
            guestCreationFailed: "NO SE PUDO CREAR INVITADO. ¿PROBAR INICIO DE SESIÓN?",
            verifyingPurchase: "Verificando compra...",
            premiumActivated: "¡PREMIUM ACTIVADO! ENERGÍA INFINITA!",
            purchaseCanceled: "Compra cancelada.",
            coinsAdded: "+{amount} MONEDAS! 💰",
            challengeComplete: "¡DESAFÍO COMPLETO! {stars} ESTRELLA(S)!",
            runEndedScore: "RUN TERMINADO. PUNTUACIÓN: {score}",
            noEnergyLeft: "¡SIN ENERGÍA!",
            accountSaved: "¡CUENTA GUARDADA!"
        },
        convert: {
            title: "GUARDAR PROGRESO",
            description: "Convierte tu cuenta de invitado para guardar tus monedas y tu progreso de forma permanente.",
            newUsername: "NUEVO NOMBRE DE USUARIO",
            confirmPassword: "CONFIRMAR CONTRASEÑA",
            saveProfile: "GUARDAR MI PERFIL",
            later: "MÁS TARDE"
        },
        errors: {
            loginRequiredFields: "Por favor ingresa email y contraseña",
            emailRequired: "Por favor ingresa tu email",
            allFieldsRequired: "Todos los campos son obligatorios",
            passwordMismatch: "Las contraseñas no coinciden",
            invalidResetLink: "Enlace de restablecimiento inválido",
            loginFirst: "Primero inicia sesión"
        },
        challenges: {
            runTitle: "RUN DE DESAFÍO",
            backToMenu: "VOLVER AL MENÚ"
        },
        cookies: {
            message: "Usamos cookies para mejorar tu experiencia y recordar tu progreso, conforme al RGPD. Al continuar, aceptas nuestro uso de cookies.",
            accept: "ACEPTAR",
            refuse: "RECHAZAR"
        },
        allGames: {
            title: "TODOS LOS JUEGOS",
            banner: "Descubre juegos nuevos en modo <strong>INFINITO</strong> para desbloquearlos aquí, practicar y hacer récords.",
            unlockedLabel: "DESBLOQUEADOS:",
            searchPlaceholder: "BUSCAR JUEGOS...",
            champ: "CAMPEÓN"
        },
        shop: {
            title: "TIENDA",
            colors: "COLORES",
            effects: "EFECTOS",
            coins: "MONEDAS"
        },
        leaderboard: {
            title: "CLASIFICACIONES",
            searchPlaceholder: "BUSCAR CLASIFICACIONES...",
            globalRank: "RANGO GLOBAL",
            top: "TOP",
            noScores: "SIN PUNTUACIONES AÚN",
            noScoresShort: "Sin puntuaciones aún.",
            previewLoading: "CLASIFICACIÓN (CARGANDO...)",
            singleTitle: "CLASIFICACIÓN"
        },
        profile: {
            title: "MI PERFIL",
            xpProgress: "PROGRESO XP",
            stats: "ESTADÍSTICAS",
            totalCoins: "MONEDAS:",
            gamesUnlocked: "JUEGOS DESBLOQUEADOS:",
            promotionLink: "ENLACE DE PROMOCIÓN",
            promotionHint: "¡Los mejores jugadores pueden promocionar un enlace aquí!",
            saveLink: "GUARDAR ENLACE",
            personalBests: "MEJORES MARCAS",
            emptyBestsHint: "¡Aún no hay mejores puntuaciones! 🎮<br><br>Juega en <strong>MODO INFINITO</strong> o en <strong>CHALLENGES</strong> para ver aquí tus mejores marcas y subir en las clasificaciones.",
            levelShort: "NVL",
            languageLabel: "Idioma:"
        },
        friends: {
            title: "AMIGOS",
            yourCode: "TU CÓDIGO:",
            enterCode: "INGRESAR CÓDIGO",
            add: "AÑADIR",
            noFriendsYet: "Aún no tienes amigos.",
            invalidCode: "FORMATO DE CÓDIGO INVÁLIDO",
            added: "¡AMIGO AÑADIDO!",
            noFriendsAdded: "Aún no has añadido amigos.",
            shareCode: "¡Comparte tu código!",
            view: "VER",
            friendStats: "Estadísticas del amigo"
        },
        games: {
            TapGame: "Tap",
            SwipeGame: "Desliza",
            MazeGame: "Laberinto",
            SoccerGame: "Fútbol",
            HoldGame: "Mantén",
            ShakeGame: "Agita",
            ChargeGame: "Carga",
            DodgeGame: "Esquiva",
            MatchGame: "Empareja",
            TypeGame: "Escribe",
            SpinGame: "Gira",
            CatchGame: "Atrapa",
            CountGame: "Cuenta",
            FindGame: "Busca",
            ConnectGame: "Conecta",
            DontMoveGame: "No Te Muevas",
            PumpGame: "Bombea",
            SliceGame: "Corta",
            UnlockGame: "Desbloquea",
            SortGame: "Ordena",
            StopwatchGame: "Cronómetro",
            WhackGame: "Golpea",
            DefendGame: "Defiende",
            BalanceGame: "Equilibra",
            AlignGame: "Alinea",
            FillGame: "Llena",
            StackGame: "Apila",
            CleanGame: "Limpia",
            CrackGame: "Rompe",
            TraceGame: "Traza",
            DodgeVerticalGame: "Zambúllete",
            SimonGame: "Simon",
            MathGame: "Mates",
            ShootGame: "Disparo",
            FanGame: "Ventilador",
            OrderGame: "Orden",
            JumpGame: "Salto",
            DuckGame: "Agáchate",
            ReelGame: "Carrete",
            ShaveGame: "Afeita",
            PetGame: "Calma",
            ToastGame: "Tostada",
            AnswerGame: "Respuesta",
            HighFiveGame: "Choca Esos Cinco",
            DrinkGame: "Bebe",
            BlowGame: "Sopla",
            ScratchGame: "Rasca",
            SquashGame: "Aplasta",
            GolfGame: "Golf",
            BowlingGame: "Bolos",
            ArcheryGame: "Arquería",
            SnatchGame: "Arrebata",
            SafeCrackGame: "Caja Fuerte",
            MorseGame: "Morse",
            MergeGame: "Fusiona",
            PeelGame: "Pela",
            ScaleGame: "Balanza",
            TugGame: "Tira y Afloja",
            ParkGame: "Aparca",
            FlySwatGame: "Mata Moscas",
            BasketGame: "Canasta",
            TrafficGame: "Tráfico",
            UmbrellaGame: "Paraguas",
            FlipGame: "Giro",
            SawGame: "Sierra",
            TankGame: "Tanque",
            ZipperGame: "Cremallera",
            NeedleGame: "Aguja",
            PizzaGame: "Pizza",
            PlugGame: "Enchufe",
            UnscrewGame: "Desatornilla",
            RipGame: "Rasga",
            SprayGame: "Spray",
            TunerGame: "Afinador",
            FileGame: "Lima",
            IgniteGame: "Enciende",
            CrushGame: "Machaca",
            StampGame: "Sella",
            ShredGame: "Tritura",
            FlickGame: "Toque",
            DunkGame: "Mate",
            SpreadGame: "Unta",
            UnrollGame: "Desenrolla",
            PokeGame: "Pincha",
            FishGame: "Pesca",
            SkateGame: "Skate",
            KiteGame: "Cometa",
            PingPongGame: "Ping Pong",
            PlantGame: "Planta",
            PianoGame: "Piano",
            PoolGame: "Billar",
            DartGame: "Dardo",
            CardGame: "Carta",
            PhotoGame: "Foto",
            OrbitGame: "Órbita",
            MagnetGame: "Imán",
            RopeGame: "Cuerda",
            ReactionGame: "Reacción",
            KeepUpGame: "No Caigas",
            SpaceGame: "Espacio"
        },
        ui: {
            guestAccountLabel: "CUENTA INVITADO: REGÍSTRATE PARA GUARDAR TU PROGRESO!"
        },
        microgames: {
            survive: "¡SOBREVIVE!",
            ready: "¿LISTO?"
        },
        tutorial: {
            controls: "CONTROLES",
            objective: "OBJETIVO",
            play: "JUGAR",
            close: "CERRAR",
            tapToPlay: "TOCA PARA EMPEZAR",
            badge: "?",
            watchDemo: "MIRA CÓMO GANAR",
            autoResume: "REANUDACIÓN EN {seconds}s",
            skipDemo: "CONTINUAR",
            dontShowAgain: "NO MOSTRAR DE NUEVO"
        }
    }
};
